import React from "react";

import { Checkbox, FormField, FormRadioButtons, PanelFilters, Text } from "@performyard/py-components";

import {
	type CompetenciesFilterForm,
	CompetenciesFilterFormSchema,
	type CompetenciesFilters,
	STATUS_OPTIONS,
} from "./schema";

type CompetenciesFilterPanelProps = {
	isOpen: boolean;
	onClose: () => void;
	filters: CompetenciesFilters;
	onApplyFilters: (filters: CompetenciesFilters) => void;
};

export const CompetenciesFilterPanel = ({ isOpen, onClose, filters, onApplyFilters }: CompetenciesFilterPanelProps) => {
	const defaultValues: CompetenciesFilterForm = {
		status: filters.status,
		companyWide: filters.companyWide === true,
	};

	const handleSubmit = ({ value }: { value: CompetenciesFilterForm }) => {
		const applied: CompetenciesFilters = { status: value.status };
		if (value.companyWide) {
			applied.companyWide = true;
		}
		onApplyFilters(applied);
		onClose();
	};

	return (
		<PanelFilters
			isOpen={isOpen}
			onClose={onClose}
			schema={CompetenciesFilterFormSchema}
			defaultValues={defaultValues}
			onSubmit={handleSubmit}
		>
			<div className="space-y-4">
				<FormRadioButtons<CompetenciesFilters["status"]> id="status" label="Status" options={STATUS_OPTIONS} />
				<FormField<boolean>
					id="companyWide"
					input={({ value, onChange }) => (
						<label htmlFor="companyWide" className="flex cursor-pointer items-center gap-2">
							<Checkbox
								id="companyWide"
								checked={value === true}
								onCheckedChange={(checked) => onChange(checked === true)}
								aria-label="Only show company-wide competencies"
							/>
							<Text size="paragraph-3">Only show company-wide competencies</Text>
						</label>
					)}
				/>
			</div>
		</PanelFilters>
	);
};

export default CompetenciesFilterPanel;
